import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const SelectionPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: ${props => props.$isCollapsed ? '12px 24px' : '24px'};
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;

  ${props => props.$isCollapsed && `
    justify-content: center;
  `}

  ${props => !props.$visible && `
    padding: 0;
  `}
`;

export const SelectionPanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Label = styled.span`
  color: ${COLORS.PRIMARY};
  font-weight: 500;
  font-size: 14px;
`;

export const SelectionInfo = styled.span`
  font-size: 12px;
  color: #666;
  margin-left: 8px;
`; 